// extracted by mini-css-extract-plugin
module.exports = {"tacdisable":"customInput_tacdisable__ViM9s","opacityField":"customInput_opacityField__0qRu_","marginErr":"customInput_marginErr__3cH4R"};